import * as o from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/PushPinSlash.es.js";
const s = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...a, weights: t }));
s.displayName = "PushPinSlashIcon";
const m = s;
export {
  m as PushPinSlash,
  s as PushPinSlashIcon
};
